import { render, staticRenderFns } from "./serviceTag.vue?vue&type=template&id=f3708900&scoped=true"
import script from "./serviceTag.vue?vue&type=script&lang=js"
export * from "./serviceTag.vue?vue&type=script&lang=js"
import style0 from "./serviceTag.vue?vue&type=style&index=0&id=f3708900&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3708900",
  null
  
)

export default component.exports